import { Injectable, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable()
export class TranslatorService {
	public currentLangEmitter$ : BehaviorSubject<String> = new BehaviorSubject<String>('');
	private _langCache = new Map<string, Observable<any>>();

	constructor(public translate: TranslateService, private _ngZone: NgZone) {
	}

	async init(lang : any) {
		this.translate.setFallbackLang(lang);
		this.translate.use(lang);
		this.currentLangEmitter$.next(lang);
	}

	/** Ensures ngx-translate has an active language; call on app bootstrap and when login remounts after in-app logout. */
	initFromStoredLanguageOrDefault(): void {
		if (!localStorage) {
			return;
		}
		let lan = localStorage.getItem('language');
		if (lan == null || lan === '') {
			lan = 'en';
			localStorage.setItem('language', lan);
		}
		void this.init(lan);
	}

	changeLanguage(lang : any) {
		this._ngZone.run(() => {
			this.translate.use(lang);
			this.currentLangEmitter$.next(lang);
		});
	}

	isRTL = () => {
		return this.translate.currentLang() === 'iw';
	}

	selectedLang = () => {
		let rc = localStorage.getItem('language');
		
		switch (rc) {
			case 'iw':
				rc = 'עב';
				break;
			case 'en':
				rc = 'EN';
				break;
			case 'pl':
				rc = 'PL';
				break;
			default:
				rc = 'EN';
		}
		return rc;
	}

	getTranslationLanguage = () => {
		let rc = localStorage.getItem('language');

		switch (rc) {
			case 'iw':
				rc = 'iw';
				break;
			case 'en':
				rc = 'en';
				break;
			case 'pl':
				rc = 'pl';
				break;
			default:
				rc = 'en';
		}
		return rc;
	}

	getTranslation(lang: any): Observable<any> {
		const key = String(lang || '');

		if (!this._langCache.has(key)) {
			/* Prefer the translations ngx-translate already holds. reloadLang() drops
			   the language from the store BEFORE re-fetching it, so every `| translate`
			   already rendered has nothing to resolve against until the request comes
			   back - that is the flash of raw keys ("LOGIN.SIGN_IN", "TITLES.CLUSTERS")
			   on a hard refresh. Only hit the network when the language isn't loaded. */
			const loaded = key ? this.translate.getTranslations(key) : null;
			const req$ = loaded && Object.keys(loaded).length > 0
				? of(loaded as any)
				: this.translate.reloadLang(key);
			this._langCache.set(key, req$);
		}

		return this._langCache.get(key)!;
	}

}
